import Model from "./Model.js";

/**
 * `Cache` saves, deletes and handles objects that are stored as a property on its instances.
 * Different instances of this class is used to store different data categories.
 * It is required for cached objects to have a getId() method.
 */
export default class Cache extends Model {
	constructor(spec = {}) {
		super(spec);
		this._objects = {};
	}

	flush() {
		this._objects = {};
	}

	getAll() {
		return Object.values(this._objects);
	}

	getAllAsMap() {
		return { ...this._objects };
	}

	registerAll(objects) {
		objects.forEach((object) => {
			this.register(object);
		});
	}

	register(object) {
		const id = this._getId(object);

		this._objects[id] ||= object;
	}

	unregister(object) {
		const id = this._getId(object);
		if (this._objects[id]) {
			delete this._objects[id];
		}
	}

	get(id) {
		return this._objects[id];
	}

	_getId(object) {
		return object.getId();
	}
}
